import React from "react";
import PropTypes from "prop-types";
import TreeItemStore from "data/TreeItemStore";
import TreeItemActions from "data/TreeItemActions";
import Dispatcher from "Dispatcher";
import TableStore from "data/TableStore";
import MappingStore from "data/MappingStore";
import entityMetaStore from "data/meta/entityMetaStore";
import MapDialogActions from "data/MapDialogActions";
import BuildMappingTreeVisitor from "data/selectors/BuildMappingTreeVisitor";
import TableAccess from "data/util/TableAccess";
import OverStore from "data/OverStore";
import useFluxStore from "@armus/use-flux-store";
import RootTreeLayout from "../../mapping/views/recordsourcetreegrid/RootTreeLayout";

export const FluxMergeRecordSourceTreeGridLayout = (props) => {
    const {ctx, isKeyExpanded} = props;
    const state = useFluxStore((prevState) => {
        if (OverStore.isModalShowing()) return prevState;
        if (!MappingStore.isReady()) return prevState;

        const tree = new BuildMappingTreeVisitor(
            MappingStore.getState(),
            new TableAccess(TableStore.getState()),
            new TableAccess(TableStore.getSnapshot()),
        )
            .execute()
            .getTree();

        const sourceKey = tree.source.entityKey;
        const targetKey = tree.target.entityKey;
        const treeItemState = TreeItemStore.getState(ctx);
        return {
            // the main goodies
            rootItem: {
                ...tree,
                depth: 0,
            },

            // chrome bits
            isMagicRoot: tree.isMagicRoot || false,
            sourceRecordType: entityMetaStore.getInfo(sourceKey).label,
            targetRecordLabel: tree.label,
            targetRecordType: entityMetaStore.getInfo(targetKey).label,

            // mapping event handlers
            onIncludeMagicRootFields: () => Dispatcher.dispatch({
                type: MapDialogActions.SET_MAGIC_ROOT_EXCLUSION,
                excluded: false,
            }),
            onExcludeMagicRootFields: () => Dispatcher.dispatch({
                type: MapDialogActions.SET_MAGIC_ROOT_EXCLUSION,
                excluded: true,
            }),

            // TreeGrid handlers
            isKeyExpanded: isKeyExpanded,
            expandedAll: treeItemState.expandAllNodes,
            onChildCollapseOrExpand: TreeItemActions.childCollapseOrExpand.bind(
                undefined,
                ctx,
            ),
            onCollapseAll: TreeItemActions.collapseAll.bind(undefined, ctx),
            onExpandAll: TreeItemActions.expandAll.bind(undefined, ctx),
        };
    }, [
        MappingStore,
        TreeItemStore,
        TableStore,
        OverStore,
    ], [ctx, isKeyExpanded]);
    return state && state.rootItem
        ? <RootTreeLayout {...state} />
        : null; // render nothing
};

FluxMergeRecordSourceTreeGridLayout.propTypes = {
    mergePlugin: PropTypes.string.isRequired,
    ctx: PropTypes.string.isRequired,
    isKeyExpanded: PropTypes.func,
};



// WEBPACK FOOTER //
// ./app/lib/merge/mergebodylayout/FluxMergeRecordSourceTreeGridLayout.js